import React from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

const DateTimePicker = ({
  labelValue,
  selectedDate,
  onDateChange,
  disabled,
  minDate,
  minTime,
  maxTime,
}) => {
  return (
    <div className="flex gap-1 w-full flex-col text-start max-w-96">
      <label className="text-stone-700 text-sm font-semibold mt-2">
        {labelValue}
      </label>
      <DatePicker
        disabled={disabled}
        selected={selectedDate}
        onChange={(date) => onDateChange(date)}
        showTimeSelect
        dateFormat="Pp"
        className="border-b border-gray-300 text-gray-900 text-sm focus:border-b focus:border-blue-500 block w-full pb-1 pt-1 outline-none"
        placeholderText="Select a date and time"
        minDate={minDate && minDate}
        minTime={minTime && minTime}
        maxTime={maxTime && maxTime}
      />
    </div>
  )
}

export default DateTimePicker
